"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Github',
  methods: {
    click: function click() {
      window.open('https://gitee.com/guchengwuyue/yshopmall', '_blank');
    }
  }
};